export default {
  CollectMoney: 'Collect Money',
  CollectionOrder: 'Collection Order',
  Payment: 'Payment',
  PaymentOrder: 'Payment Order',
  AllMerchants: 'All Merchants',
  header: {
    language: 'language',
    ChinaTime: 'All times on this platform are in China',
    Received: 'The Amount of The Order Received',
    OrderNumber: 'Quantity of Order',
    CreationOrder: 'The time attribution here is: the time the order was created',
    eg: 'For example: pull up at 9-13 23:50:00, and successfully call back the payment at 9-14 00:01:00, it will be counted as an order on the 13th in the payment background.'
  },
  search: {
    CreationStartTime: 'Creation Start Time',
    CreationEndTime: 'Creation End Time',
    OrderStatus: 'Order Status',
    GatewayQuery: 'Gateway Query',
    Inquire: 'Inquire',
    Export: 'Export',
    batchPayOutDate: 'Query the time of payment orders in batches',
    batchPayOutGateway: 'Query the gateway of payment orders in batches',
    batchPayOutInquire: 'Query payment orders in batches',
    StartDate: 'Start Date',
    to: 'to',
    EndDate: 'End Date',
    Refresh: 'Refresh'
  },
  table: {
    CreationTime: 'Creation Time',
    CreationTimeLocal: 'Created (US)',
    UpdateTime: 'Update Time',
    UpdateTimeLocal: 'Update Time (US)',
    UserName: 'User Name',
    Email: 'Email',
    Phone: 'Phone',
    ReasonFailure: 'Reason for Failure',
    Account: 'Account',
    OrderAmount: 'Order Amount',
    CurrencyCode: 'Currency Code',
    ExchangeRate: 'Exchange Rate',
    ExchangeRateAmount: 'Amount After Exchange',
    NumberNotifications: 'Number of Notifications',
    WhetherNotify: 'Whether to Notify',
    Forward: 'Forward',
    ForwardMessages: 'Forward Messages',
    GoBack: 'go back',
    Refund: 'Refund',
    State: 'State'
  },
  merchant: {
    PaymentChannel: 'Payment Channel',
    PaymentKey: 'Payment Key',
    PaymentChannelRemarks: 'Payment Channel Remarks',
    CollectionChannel: 'Collection Channel',
    CollectionKey: 'The key for receiving payment',
    CollectionChannelRemarks: 'Collection Channel Remarks',
    CollectionWeightStatus: 'Collection weight status',
    limitedTime: 'limited time',
    PayWeightStatus: 'Pay weight status',
    TotalCollectionAmount: 'Daily limit of total collection amount',
    LowerSinglePayAmount: 'The lower limit of a single payment amount',
    SupperSinglePayAmount: 'The upper limit of a single payment amount',
    AccountBalancePaid: 'Account balance (can be paid on behalf of)',
    SingleLowerCollectionAmount: 'The single lower limit of the collection amount',
    SingleUpperCollectionAmount: 'Single upper limit of collection amount',
    TotalPaymentToday: 'Total payment received today',
    TotalCurrentReceipts: 'Total Current Receipts (to be transferred)',
    WithdrawalFee: 'Withdrawal Fee',
    PayProcessingFees: 'Pay Processing Fees',
    TransferAmount: 'Transfer Amount'
  },
  PaymentTrends: {
    PaymentTrends: 'Payment Trends',
    PullupToday: 'Pull up the number of pens today',
    SuccessfulToday: 'Today\'s successful transactions',
    PullupYesterday: 'Pulled up yesterday',
    SuccessfulYesterday: 'Number of successful transactions yesterday',
    PullupLastWeek: 'Pulled up last week',
    SuccessfulLastWeek: 'Number of successful transactions last week',
    Pullup: 'Number of pens drawn {channel}',
    Successful: 'Number of successful transactions {channel}'
  },
  common: {
    PlatformOrderID: 'Platform Order ID',
    MerchantID: 'Merchant ID',
    MerchantOrderNumber: 'Merchant Order Number',
    ApplicationName: 'Application Name',
    MerchantName: 'Merchant Name',
    SecretKey: 'Secret Key',
    UserID: 'User ID',
    Country: 'Country',
    Gateway: 'Gateway',
    GatewayID: 'Gateway ID',
    Channel: 'Channel',
    ChannelName: 'Channel Name',
    PaymentChannel: 'Payment Channel',
    AddAmount: 'Add Amount',
    Edit: 'Edit',
    Delete: 'Delete',
    Operate: 'Operate',
    Collectionbalance: 'Collection balance',
    Availablechannel: 'available channel',
    AddAvailablechannel: 'Add available channel',
    CurrentChannelConfig: 'current channel config',
    AddChannel: 'Add channels'
  },
  general: {
    index: 'No.',
    operations: 'Operations',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    tip: 'Tip',
    getDataFailed: 'Failed to get data',
    addSuccess: 'Added successfully',
    addFailed: 'Failed to add',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete'
  },
  trustDecision: {
    whitelist: 'Whitelist Management',
    addIP: 'Add IP',
    addWhitelist: 'Add Whitelist',
    ipAddress: 'IP Address',
    enterIP: 'Please enter IP address',
    confirmDelete: 'Confirm delete this IP?',
    invalidIP: 'Invalid IP address format',
    ipRequired: 'Please enter IP address'
  }
};